import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { CommandPalette } from './layout/command-palette/command-palette';
import { ShellHeader } from './layout/shell-header/shell-header';
import { ShellSidebar } from './layout/shell-sidebar/shell-sidebar';
import { StaleBuildBanner } from './layout/stale-build-banner/stale-build-banner';

/**
 * The shell frame. Every screen, module or not, renders inside it: the one
 * navigation runs the full height on the left — brand, company, destinations
 * and the signed-in user in a single dark column — and the right side stacks
 * the header over the routed content.
 */
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ShellHeader, ShellSidebar, CommandPalette, StaleBuildBanner],
  template: `
    <app-command-palette />

    <app-shell-sidebar />

    <div class="shell-column">
      <!-- Above the header, so it is the first thing seen once a redeploy has
           left this tab behind; renders nothing until then. -->
      <app-stale-build-banner />
      <app-shell-header />

      <main class="shell">
        <router-outlet />
      </main>
    </div>
  `,
  styleUrl: './app.scss',
})
export class App {}
